import { Injectable } from '@angular/core'
import { CommonService } from '../../shared/services/common.service'
import { BreadcrumbService } from '../../shared/components/breadcrumb/breadcrumb.service'
export const headerOptions = { responseType: 'text' as 'json' }

@Injectable({
  providedIn: 'root',
})
export class PlpService {
  constructor(
    public commonService: CommonService,
    private breadCrumbService: BreadcrumbService
  ) {}

  updateProductFavouriteStatus(product, value?) {
    const urlparams = ['users', 'current', 'saveProductsToFavourites']
    const apiUrl = this.commonService.constructUrl(urlparams)
    const formData = new FormData()
    formData.append('code', product.code)
    formData.append('comment', value)
    return this.commonService.postData(apiUrl, formData, headerOptions)
  }

  setCategoryBreadCrumbs(catCode) {
    const urlParam = ['vsCategories', 'breadcrumb', catCode]
    const url = this.commonService.constructUrl(urlParam)
    this.commonService.getData(url).subscribe((res: any) => {
      const breadcrumbs = []
      for (const value of res) {
        const item = { label: '', link: '' }
        item.label = value.name
        item.link = value.url
        breadcrumbs.push(item)
      }
      this.breadCrumbService.setBreadCrumbs(breadcrumbs)
    })
  }
}
